<template>
<div class="z-main">
	<header class="z-header">
		<div><router-link to="/my"><img src="../../assets/sysbars/left.png" /></router-link></div>
		<div>切换子账号</div>
		<div></div>
	</header>
	<div class="z-body z-body-bottom0">
		<div v-for="(item,index) in data" class="z-subAccount-item" @click="cutswitch(item.uid)">
			<div class="z-subAccount-user">
				<img :src="item.avatar" class="z-user-avatar">
				<div class="z-subAccount-info">
					<div v-text="item.name"></div>
					<div v-text="'交易号：'+(item.trade_account ? item.trade_account : '待入金')"></div>
				</div>
			</div>
			<div class="z-subAccount-state" v-if="item.uid == getUid()">
				<img src="../../assets/index/sub-account/yes.png" class="z-icon">
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'subAccount',
	data() {
		return {
			data:[]
		}
	},
	created() {
		let _this = this
		_this.get('api/users/childs',{}).then((rs)=>{
			this.data = rs.data
		})
	},
	methods: {
		cutswitch(uid){
			this.post('api/users/cutswitch',{uid:uid}).then((rs)=>{
				this.$store.commit('layer',rs.msg)
				if (rs.code==0) {
					this.setToken(rs.data.token)
					this.setUid(uid)
					this.jump('/my')
				}
			})
		}
	}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.z-subAccount-item {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
	padding: 10px;
	border-bottom: 1px solid #515151;
}
.z-subAccount-user {
	display: -webkit-flex;
	display: flex;
	justify-content:space-between;
	align-items:center;
}
.z-subAccount-info div:nth-child(2) {
	font-size: 10px;
	color: #9B9A9C;
}
.z-icon {
	width: 18px;
	height: 18px;
}
</style>



// WEBPACK FOOTER //
// src/pages/index/subAccount.vue